export const SEO_MODULE_GLOBAL = Symbol('seoModuleGlobal');
export const SEO_MODULE_PRODUCT = Symbol('seoModuleProduct');
export const SEO_MODULE_CATEGORY = Symbol('seoModuleCategory');
export const SEO_MODULE_CMS = Symbol('seoModuleCms');
